//
// Generated class BookingGuest
//

/// <reference path="BookingGuest_ManagedObject.ts" />

class BookingGuest extends BookingGuest_ManagedObject
{
}
